import React, { Component } from "react";
import client, { makeGet, makePaginatedGet } from "@culturehq/client";

import { errorService } from "app/utils";

import NotificationBell from "./NotificationBell";
import PointsTrophy from "./PointsTrophy";

class NotificationContainer extends Component {
  state = {
    seenNotifications: [],
    unseenNotifications: []
  };

  componentDidMount() {
    this.componentIsMounted = true;

    this.loadSeenNotifications();
    this.loadUnseenNotifications();
  }

  componentDidUpdate(prevProps, prevState) {
    const { unseenNotifications } = this.state;

    if (prevState.unseenNotifications.length !== unseenNotifications.length) {
      this.handleUnseenCountChange();
    }
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  static getDerivedStateFromProps(newProps, prevState) {
    const { newNotifications } = newProps;
    const lastNotification = newNotifications[newNotifications.length - 1];

    const { unseenNotifications } = prevState;

    if (lastNotification && lastNotification !== unseenNotifications[0]) {
      return { unseenNotifications: [lastNotification, ...unseenNotifications] };
    }

    return null;
  }

  loadSeenNotifications = async () => {
    const { onListSeen } = this.props;

    try {
      const { notifications } = await onListSeen();

      if (this.componentIsMounted) {
        this.setState({ seenNotifications: notifications });
      }
    } catch (error) {
      errorService.error(error);
    }
  };

  loadUnseenNotifications = async () => {
    const { onListUnseen } = this.props;

    try {
      const { notifications } = await onListUnseen();

      if (this.componentIsMounted) {
        this.setState({ unseenNotifications: notifications });
      }
    } catch (error) {
      errorService.error(error);
    }
  };

  handleNotificationsOpen = async () => {
    const { onMarkAsSeen, onNewNotificationsSeen } = this.props;

    try {
      await onMarkAsSeen();

      if (this.componentIsMounted) {
        this.handleUnseenCountChange();
        onNewNotificationsSeen();
      }
    } catch (error) {
      errorService.error(error);
    }
  };

  handleNotificationsClosed = () => {
    this.setState(({ unseenNotifications, seenNotifications }) => ({
      unseenNotifications: [],
      seenNotifications: [...unseenNotifications, ...seenNotifications]
    }));
  };

  handleUnseenCountChange = () => {
    const { onUnseenCountChange } = this.props;
    const { unseenNotifications } = this.state;

    if (onUnseenCountChange) {
      onUnseenCountChange(unseenNotifications.length);
    }
  };

  render() {
    const { component: NotificationComponent } = this.props;
    const { seenNotifications, unseenNotifications } = this.state;

    return (
      <NotificationComponent
        seenNotifications={seenNotifications}
        unseenNotifications={unseenNotifications}
        unseen={unseenNotifications.length}
        onOpen={this.handleNotificationsOpen}
        onClose={this.handleNotificationsClosed}
      />
    );
  }
}

const onListSeenNotifications = () => (
  makeGet("/profile/notifications", { seen: true })
);

const onListUnseenNotifications = () => (
  makePaginatedGet("notifications", "/profile/notifications", { seen: false })
);

export const MainNotificationContainer = props => (
  <NotificationContainer
    {...props}
    component={NotificationBell}
    onListSeen={onListSeenNotifications}
    onListUnseen={onListUnseenNotifications}
    onMarkAsSeen={client.createProfileNotificationView}
  />
);

const onListSeenPointNotifications = () => (
  makeGet("/profile/point_notifications", { seen: true })
    .then(({ pointNotifications, ...rest }) => ({
      notifications: pointNotifications,
      ...rest
    }))
);

const onListUnseenPointNotifications = () => (
  makePaginatedGet("pointNotifications", "/profile/point_notifications", { seen: false })
    .then(({ pointNotifications, ...rest }) => ({
      notifications: pointNotifications,
      ...rest
    }))
);

export const PointNotificationContainer = props => (
  <NotificationContainer
    {...props}
    component={PointsTrophy}
    onListSeen={onListSeenPointNotifications}
    onListUnseen={onListUnseenPointNotifications}
    onMarkAsSeen={client.createProfilePointNotificationView}
  />
);
